const autoNgTemplateLoaderTemplate1 = require('./template.html');

angular.module('portainer.kubernetes').component('kubernetesApplicationPlacementsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesApplicationPlacementsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    refreshCallback: '<',
    loading: '<',
    removeAction: '<',
  },
});
